import { render, staticRenderFns } from "./vuetifyaudio.vue?vue&type=template&id=ebf0a8d0&"
import script from "./vuetifyaudio.vue?vue&type=script&lang=js&"
export * from "./vuetifyaudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports